import { classes } from "@r8er/lib/utils";
import type { InputHTMLAttributes} from "react";
import { forwardRef, useEffect, useState } from "react";
import styles from "./Input.module.css";
import type { OnInputChangeCB } from "./onChange";
import { OnInputChange } from "./onChange";

export interface InputShortTextProps
  extends Omit<
    InputHTMLAttributes<HTMLInputElement>,
    "onChange" | "defaultChecked" | "type"
  > {
  id: string;
  name: string;
  defaultValue?: InputHTMLAttributes<HTMLInputElement>["defaultValue"];

  onChange?: OnInputChangeCB;

  theme?: {
    input?: string;
  };
}

export type InputShortTextHandlers = {
  setValue(value: string[]): void;
};

export const InputShortText = forwardRef<
  InputShortTextHandlers,
  InputShortTextProps
>(({ id, name, defaultValue, onChange, theme, ...props }, ref) => {
  const [value, setValue] = useState(defaultValue ?? "");

  useEffect(() => {
    setValue(defaultValue ?? "");
  }, [defaultValue]);

  return (
    <input
      {...props}
      type="text"
      id={id}
      value={value}
      name={name}
      onChange={OnInputChange(onChange, value, setValue)}
      className={classes(styles.input, theme?.input, props?.className)}
    />
  );
});
